// Code from https://gist.github.com/ca0v/73a31f57b397606c9813472f7493a940

export default function debounce<T extends Function>(
    func: T,
    delay: number
): ((...args: any[]) => void) & { cancel: () => void } {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    
    const debouncedFunction = function (this: any, ...args: any[]) {
        const context = this;
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func.apply(context, args);
            timeoutId = null;
        }, delay);
    } as ((...args: any[]) => void) & { cancel: () => void };
    
    debouncedFunction.cancel = function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    
    return debouncedFunction;
}